<template>
  <div v-if="brand_info.site_name" style="display: block;height: 100%;width: 100%" :class="[$route.name.toLocaleLowerCase()+'-page']">
    <div v-if="brand_info.air_login_page_style==='style_1'" class="login_box_default air_login_page_style_1" :style="{ backgroundImage: `url(${brand_info.air_login_bg_img})` }">
        <div class="login_body">
          <img class="login_body_image" :src="brand_info.air_login_layer_bg_img" alt="">
          <div class="login_form_wrap">
            <div class="bd2 flex-col">
              <div class="layer1 flex-row justify-between-login-from">
                <div @click="tabToggle('normalLogin')" :class="tab.activeName==='normalLogin'?'ui-tab-nav active':'ui-tab-nav'">
                  <img  class="air_login_page_style_1_title_image" :src="brand_info.air_login_layer_title_img" alt="">
                </div>
              </div>
              <div class="normalLogin" v-if="tab.activeName==='normalLogin'">
                <div class="field">
                  <img class="icon-img" src="../../assets/login_v2/username.png" alt="">
                  <input autocomplete="off" v-model="mobile" name="mobile"
                         class="ui-input layer2 flex-col justify-center" type="text" placeholder="手机号">
                </div>
                <div class="field">
                  <img class="icon-img" src="../../assets/login_v2/password.png" alt="">
                  <input autocomplete="off" v-model="password" name="password" type="password"
                         class="ui-input layer2 flex-col justify-center" placeholder="密码">
                </div>
              </div>
              <div class="normalLogin" v-if="tab.activeName==='phoneCodeLogin'">
                <div class="field">
                  <input autocomplete="off" v-model="mobile" name="mobile"
                         class="ui-input layer2 flex-col justify-center" type="text" placeholder="手机号">
                </div>
                <div class="field">
                  <input autocomplete="off" v-model="phoneValidateCode" name="phoneValidateCode" type="text"
                         class="ui-input layer2 flex-col justify-center" placeholder="手机验证码">
                  <div @click="sendPhoneValidateCode" :class="styles.sendPhoneValidateCodeBtn">
                    {{ this.sendPhoneValidateCodeText }}
                  </div>
                </div>
              </div>
              <div class="login_btn_default"  @click="submitForm">
                <img class="login_btn_default_image" :src="brand_info.air_login_layer_btn_img" alt="">
              </div>
              <div class="login_form_footer">
                <div class="left">
                  登录即视为同意  <span
                    :style="{ color: `${brand_info.air_text_active_color}` }"
                    class="yonghuxieyi">用户协议、隐私协议</span>
                </div>
                <div class="right"
                     :style="{ color: `${brand_info.air_text_active_color}` }"
                >
                  <span @click="resetPwd">忘记密码</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div v-else-if="brand_info && brand_info.single_user_data===1" v-show="brand_info" :class="['login_page_default']">
      <div class="w1200" style="width: 900px">
        <div class="paomadeng" v-if="top_msg" v-show="top_msg" @click="toMsgShow(top_msg)">
          <div class="left">
            <img src="../../assets/index_v2/tz-icon-v2.png" alt="">
            通知
          </div>
          <div class="right">
            <marquee direction="left" loop="loop">{{top_msg.title}}</marquee>
          </div>
        </div>
      </div>
      <template v-if="userInfo.username">
          <div class="skin_1_title"
               :style="{ color: `${brand_info.air_text_active_color}` }"
          >
            智能英语学习系统
          </div>
          <div class="skin_1_desc"
               :style="{ color: `${brand_info.air_text_active_color}` }"
          >
            AI人工智能推动英语教育
          </div>
          <div class="items">
            <div class="item wodekebiao" @click="toggle_kebiao()">
              <template v-if="kebiao_close">
                <div class="bg">
                  <img :src="this.brand_info.air_home_wdkb_bg_close_img" alt="我的课表-展开">
                </div>
              </template>
              <template v-else>
                <div class="bg">
                  <img :src="this.brand_info.air_home_wdkb_bg_open_img" alt="我的课表-收起">
                </div>
                <img @click="()=>this.$router.push('/mycourse')" class="btn" src="../../../src/assets/homepage_v2/home_btn_ksxx.png" alt="我的课表-开始学习">
              </template>
            </div>
            <div class="item mingzhuyuedu" @click="toggle_mingzhu()">
              <template v-if="mingzhu_close">
                <div class="bg">
                  <img v-if="brand_info.is_show_famous_read"  :src="this.brand_info.air_home_mzyd_bg_enable_close" alt="名著阅读-enable-关">
                  <img v-else :src="this.brand_info.air_home_mzyd_bg_disable_close" alt="名著阅读-disable-关">
                </div>
              </template>
              <template v-else>
                <div class="bg">
                  <img v-if="brand_info.is_show_famous_read"   :src="this.brand_info.air_home_mzyd_bg_enable_open" alt="名著阅读-enable-开">
                  <img v-else  :src="this.brand_info.air_home_mzyd_bg_disable_open" alt="名著阅读-disable-开">
                </div>
                <img @click="()=>this.$router.push('/famous_read')"   v-if="brand_info.is_show_famous_read"   class="btn" src="../../../src/assets/homepage_v2/kaishiyuedu.png" alt="名著阅读-disable-开始按钮">
                <img v-else class="btn" src="../../../src/assets/homepage_v2/home_btn_wkt_disable.png" alt="名著阅读-disable-开始按钮">
              </template>
            </div>
            <div class="item cihuiliangceping" @click="toggle_cihuiliangceping()">
              <template v-if="cihuiliangceping_close">
                <div class="bg">
                  <img :src="this.brand_info.air_home_ceping_bg_close" alt="词汇量测评-close">
                </div>
              </template>
              <template v-else>
                <div class="bg">
                  <img :src="this.brand_info.air_home_ceping_bg_open" alt="词汇量测评-open">
                </div>
                <img @click="()=>this.$router.push('/word_test')" class="btn" src="../../../src/assets/homepage_v2/kaishiceping.png" alt="词汇量测评-btn">
              </template>
            </div>
          </div>
      </template>
      <template v-else>
          <template v-if="brand_info.air_login_page_style==0">
            <div class="login_box_default" :style="{ backgroundImage: `url(${brand_info.air_login_bg_img})` }">
                  <div class="login_body">
                    <img class="login_body_image" :src="brand_info.air_login_layer_bg_img" alt="">
                    <div class="login_form_wrap">
                      <div class="bd2 flex-col">
                        <div class="layer1 flex-row justify-between-login-from">
                          <div @click="tabToggle('normalLogin')" :class="tab.activeName==='normalLogin'?'ui-tab-nav active':'ui-tab-nav'">
                            <img :src="brand_info.air_login_layer_title_img" alt="">
                          </div>
                        </div>
                        <div class="normalLogin" v-if="tab.activeName==='normalLogin'">
                          <div class="field">
                            <img class="icon-img" src="../../assets/login_v2/username.png" alt="">
                            <input autocomplete="off" v-model="mobile" name="mobile"
                                   class="ui-input layer2 flex-col justify-center" type="text" placeholder="手机号">
                          </div>
                          <div class="field">
                            <img class="icon-img" src="../../assets/login_v2/password.png" alt="">
                            <input autocomplete="off" v-model="password" name="password" type="password"
                                   class="ui-input layer2 flex-col justify-center" placeholder="密码">
                          </div>
                        </div>
                        <div class="normalLogin" v-if="tab.activeName==='phoneCodeLogin'">
                          <div class="field">
                            <input autocomplete="off" v-model="mobile" name="mobile"
                                   class="ui-input layer2 flex-col justify-center" type="text" placeholder="手机号">
                          </div>
                          <div class="field">
                            <input autocomplete="off" v-model="phoneValidateCode" name="phoneValidateCode" type="text"
                                   class="ui-input layer2 flex-col justify-center" placeholder="手机验证码">
                            <div @click="sendPhoneValidateCode" :class="styles.sendPhoneValidateCodeBtn">
                              {{ this.sendPhoneValidateCodeText }}
                            </div>
                          </div>
                        </div>
                        <div class="login_btn_default"  @click="submitForm">
                          <img class="login_btn_default_image" :src="brand_info.air_login_layer_btn_img" alt="">
                        </div>
                        <div class="login_form_footer">
                          <div class="left">
                            登录即视为同意  <span
                              :style="{ color: `${brand_info.air_text_active_color}` }"
                              class="yonghuxieyi">用户协议、隐私协议</span>
                          </div>
                          <div class="right"
                               :style="{ color: `${brand_info.air_text_active_color}` }"
                          >
                            <span @click="resetPwd">忘记密码</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
          </div>
          </template>
        </template>
    </div>
    <div v-else class="home-index-page" v-show="brand_info">
      <div class="flex-col">
        <div class="bd1 flex-col justify-between">
          <div class="box2 flex-row justify-between">
            <div style="text-align: center">
              <p style="font-size: 30px;color:#fff;margin-bottom: 1.5rem">
                大数据+人工智能 助力教育教学
              </p>
              <img
                  class="pic1"
                  referrerpolicy="no-referrer"
                  src="~assets/v2/home/chahua1.png"
              />
            </div>
            <div class="section2 flex-col" v-if="!userInfo.username">
              <div class="bd2 flex-col">
                <img
                    class="img2"
                    referrerpolicy="no-referrer"
                    v-if="logoImageUrl"
                    :src="logoImageUrl"
                />
                <div class="layer1 flex-row justify-between-login-from">
                  <div
                      style="font-size: 16px;"
                      @click="tabToggle('normalLogin')" :class="tab.activeName==='normalLogin'?'ui-tab-nav active':'ui-tab-nav'">账号登录</div>
                </div>
                <div class="normalLogin" v-if="tab.activeName==='normalLogin'">
                  <div class="field">
                    <input
                        style="margin-top: 15px"
                        autocomplete="off" v-model="mobile" name="mobile"
                           class="ui-input layer2 flex-col justify-center" type="text" placeholder="手机号">
                  </div>
                  <div class="field">
                    <input autocomplete="off" v-model="password" name="password" type="password"
                           class="ui-input layer2 flex-col justify-center" placeholder="密码">
                  </div>
                </div>
                <div class="normalLogin" v-if="tab.activeName==='phoneCodeLogin'">
                  <div class="field">
                    <input autocomplete="off" v-model="mobile" name="mobile"
                           class="ui-input layer2 flex-col justify-center" type="text" placeholder="手机号">
                  </div>
                  <div class="field">
                    <input autocomplete="off" v-model="phoneValidateCode" name="phoneValidateCode" type="text"
                           class="ui-input layer2 flex-col justify-center" placeholder="手机验证码">
                    <div @click="sendPhoneValidateCode" :class="styles.sendPhoneValidateCodeBtn">
                      {{ this.sendPhoneValidateCodeText }}
                    </div>
                  </div>
                </div>
                <div class="layer4 flex-row justify-between-forget-password">
                  <span @click="resetPwd" class="txt1">忘记密码</span>
                  <img
                      class="label1"
                      referrerpolicy="no-referrer"
                      src="~assets/v2/home/img-sanjiao.png"
                  />
                </div>
                <div :class="styles.uiSubmitButton" @click="submitForm">登录</div>
                <div class="layer6">
                  <span class="word2">登录即视为同意&nbsp;</span>
                  <span class="info6">用户协议、隐私政策</span>
                </div>
              </div>
            </div>
            <div class="section2 flex-col big-user-info-box" v-if="userInfo.username">
              <div class="bd2 flex-col">
                <img
                    class="img2"
                    referrerpolicy="no-referrer"
                    src="~assets/v2/home/logo.png"
                />
                <div style="margin-top:4rem;" :class="styles.uiDisabledSubmitButton">已登录</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>

html {
  background-color: #30E7BB;
}
.login_form_footer{
  display: flex;
  overflow-wrap: break-word;
  color: rgba(131, 131, 130, 1);
  font-size: 13px;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-top: 20px;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
  .yonghuxieyi{
    color:rgba(65, 104, 39, 1);
  }
  .right{
    font-size: 15px;
    color:rgba(65, 104, 39, 1);
  }
}
.login_box_default{
  height: 100%;
  width: 100%;
  display: flex;
  background: url('../../assets/login_v2/bg.png');
  background-position:-473px -357px;
  background-repeat: no-repeat;
  background-position: center;
  margin: 0 auto;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  .login_body{
    position: relative;
    text-align: center;
    display: flex;
    width: 1000px;
    height:600px;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    .login_body_image{
      width: 100%;
    }
    .login_form_wrap{
      position: absolute;
      top:50px;
      right:50px;
      z-index: 1;
      height: 490px;
      width: 440px;
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: center;
      align-items: center;
      .layer1.flex-row.justify-between-login-from{
        height: auto;
        .ui-tab-nav{
          height: auto;
        }
      }
    }
  }
  .login_btn_default{
    display: block;
    margin-top: 20px;
    .login_btn_default_image{
      width: 100%;
    }
  }
  .normalLogin .field{
    position:relative;
    .icon-img{
      position: absolute;
      width: 30px;
      top:8px;
      left:0;
      z-index: 1;
    }
  }
  .ui-input.layer2.flex-col.justify-center{
    border: none;
    padding-left:3rem;
  }
}
.login_page_default{
  display: block;
  width: 100%;
  height: 100%;
  padding-top:65px;
  .skin_1_title{
    padding-top: 30px;
    font-weight: bolder;
    color:rgba(65, 104, 39, 1);
    text-align: center;
    font-size: 40px;
  }
  .skin_1_desc{
    margin-top: 1rem;
    color:rgba(65, 104, 39, 1);
    font-size: 16px;
    text-align: center;
  }
  .items{
    margin: 2rem auto 0;
    width: 960px;
    display: flex;
    padding-left: 90px;
    .item{
      display: block;
      position: relative;
      &.wodekebiao{
        height: 400px;
        .bg{
          img{
            height: 400px;
          }
        }
        .btn{
          position: absolute;
          left:40px;
          bottom:30px;
          width: 130px;
        }
      }
      &.mingzhuyuedu{
        height: 400px;
        margin-left: -3rem;
        .bg{
          img{
            height: 400px;
          }
        }
        .btn{
          position: absolute;
          left:40px;
          bottom:30px;
          width: 120px;
        }
      }
      &.cihuiliangceping{
        height: 400px;
        margin-left: -3rem;
        .bg{
          img{
            height: 400px;
          }
        }
        .btn{
          position: absolute;
          left:40px;
          bottom:30px;
          width: 130px;
        }
      }
    }
  }
}
.login-page .login_page_default{
  //padding-top:0;
}
button {
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
}
button:active {
  opacity: 0.6;
}
.flex-col {
  display: flex;
  height: 100%;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.justify-start {
  display: flex;
  justify-content: flex-start;
}

.justify-center {
  display: flex;
  justify-content: center;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}

.justify-evenly {
  display: flex;
  justify-content: space-evenly;
}

.justify-around {
  display: flex;
  justify-content: space-around;
}

.justify-between {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  align-content: center;
  align-items: center;
}

.justify-between-forget-password{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.justify-between-login-from{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.align-start {
  display: flex;
  align-items: flex-start;
}

.align-center {
  display: flex;
  align-items: center;
}

.align-end {
  display: flex;
  align-items: flex-end;
}

.page {
  background-color: rgba(255, 255, 255, 1);
  position: relative;
  overflow: hidden;
}

.bd1 {
}

.box1 {
  height: 79px;
  background: url(~assets/v2/home/img-line2.png)
    0px -1px no-repeat;
  padding: 13px 0 0 372px;
}

.group1 {
  width: 1148px;
  height: 56px;
}

.img1 {
  width: 176px;
  height: 56px;
}

.info1 {
  width: 167px;
  height: 23px;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 24px;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-top: 16px;
  display: block;
}

.box2 {
  width: 1000px;
  height: auto;
  margin:0 auto;
}

.pic1 {
  width: 497px;
  height: 387px;
}

.section2 {
  box-shadow: 0 10px 24px 2px rgba(1, 27, 15, 0.15);
  background-color: rgba(255, 255, 255, 1);
  border-radius: 12px;
  height:410px;
  width: 410px;
  padding: 40px 0 0 34px;
}

.bd2 {
  width: 341px;
  height: 403px;
}

.paomadeng{
  display: flex;
  margin-top: 1rem;
  background-color:rgba(236,247,255,1);
  font-weight:bold;
  .left{
    width: 100px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding:0 10px;
    img{
      margin-right: 3px;
      width: 20px;
    }
  }
  .right{
    height: 35px;
    line-height: 35px;
    flex:1;
    box-sizing: border-box;
    padding:0 5px;
    white-space: nowrap;
  }
  svg{
    fill:#fff;
    width: 15px;
    height: 15px;
  }
}


.img2 {
  width: 176px;
  //height: 56px;
  margin-left: 83px;
}

.layer1 {
  height: 20px;
  width: 100%;
  .ui-tab-nav{
    margin:0 auto;
  }
}

.word1 {
  width: 80px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(34, 34, 34, 1);
  font-size: 20px;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  display: block;
}

.info2 {
  width: 79px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(144, 144, 144, 1);
  font-size: 20px;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  display: block;
}

.pic2 {
  width: 67px;
  height: 8px;

  &.normalLogin {
    margin: 9px 0 0 53px;
  }

  &.phoneCodeLogin {
    margin: 9px 0 0 215px;
  }
}

.layer2 {
  border-radius: 8px;
  height: 49px;
  border: 1px solid rgba(209, 209, 209, 1);
  margin-top: 30px;
  padding-left: 20px;
  width: 341px;
}

.info3 {
  width: 48px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(202, 202, 202, 1);
  font-size: 16px;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  display: block;
}

.layer3 {
  border-radius: 8px;
  height: 49px;
  border: 1px solid rgba(209, 209, 209, 1);
  margin-top: 19px;
  width: 341px;
  padding: 15px 0 0 21px;
}

.info4 {
  width: 32px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(202, 202, 202, 1);
  font-size: 16px;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  display: block;
}

.layer4 {
  width: 81px;
  height: 16px;
  margin: 13px 0 0 247px;
}

.txt1 {
  width: 63px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(27, 205, 186, 1);
  font-size: 16px;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  display: block;
}

.label1 {
  width: 8px;
  height: 8px;
  margin-top: 4px;
}

.layer5 {
  background-color: rgba(27, 205, 186, 1);
  border-radius: 8px;
  height: 48px;
  width: 340px;
  margin: 13px 0 0 1px;
  padding: 16px 0 0 147px;
}

.info5 {
  width: 46px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(253, 253, 253, 1);
  font-size: 18px;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  display: block;
}

.layer6 {
  width: 233px;
  height: 14px;
  overflow-wrap: break-word;
  font-size: 0;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 20px 0 0 54px;
}

.word2 {
  width: 233px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(202, 202, 202, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
}

.info6 {
  width: 233px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(27, 205, 186, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
}

.img3 {
  z-index: 22;
  position: absolute;
  left: 250px;
  top: 108px;
  width: 299px;
  height: 140px;
}


.home-index-page {
  display: block;
  width: 100%;
  height: 100%;
  cursor: default;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-image:url(~assets/home/bg-128.jpg);
}

.ui-input {
  outline: 0;
}

.ui-tab-nav {
  height: 20px;
  cursor: pointer;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  display: block;
  color: #909090;

  &.active {
    color: #222222;
  }
}

.ui-submit-button {
  background-color: #1bcdba;
  border-radius: 8px;
  width: 340px;
  margin: 13px 0 0 1px;
  padding: 8px 0 8px 147px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  overflow-wrap: break-word;
  color: #fdfdfd;
  font-size: 18px;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.field {
  position: relative;
}

.send_phone_validate_code_btn {
  cursor: pointer;
  position: absolute;
  z-index: 1;
  height: 20px;
  width: auto;
  right: 1rem;
  top: 50%;
  color: #42B8A2;
  transform: translateY(-50%);
}

.uiDisabledSubmitButton {
  cursor: default;
  opacity: .45 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  pointer-events: none !important;

  background-color: #e0e1e2;
  border-radius: 8px;
  width: 340px;
  margin: 13px 0 0 1px;
  padding: 8px 0 8px 147px;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, .6);
  font-size: 18px;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.section2.big-user-info-box {
  height: 260px;
}

.air_login_page_style_1{
  .login_body{
    background-color: transparent;
    justify-content: inherit;
    align-items: inherit;
    .login_body_image{
      width: 462px;
      height: 500px;
    }
    .login_form_wrap{
      position: relative;
      height: 500px;
      background-color: #fff;
      top:0;
      right: 0;
    }
    .air_login_page_style_1_title_image{
      width: 200px!important;
      margin-bottom: 33px;
    }
  }
}
</style>
<script>
import { sendSms, userLogin, fastLogin,getTopMsg } from '@/services'
import ROUTER_MAP from '@/router/router-map'
import { mapState, mapMutations } from 'vuex'
import _ from 'lodash'
import mTypes from '@/store/mutationsTypes'
import store from '@/store'

export default {
  components: {},
  data () {
    return {
      top_msg:null,
      kebiao_close:true,
      mingzhu_close:true,
      cihuiliangceping_close:true,
      logoImageUrl: '',
      styles: {
        pic2: 'pic2 normalLogin',
        uiSubmitButton: 'ui-submit-button',
        uiDisabledSubmitButton: 'uiDisabledSubmitButton',
        sendPhoneValidateCodeBtn: 'send_phone_validate_code_btn',
      },
      tab: {
        activeName: 'normalLogin',
      },
      mobile: '',
      password: '',
      phoneValidateCode: '',
      submitButtonStatus: '',
      sendPhoneValidateCodeDisabled: false,
      sendPhoneValidateCodeText: '获取验证码',
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      brand_info: state => state.brand_info
    })
  },
  watch: {},
  methods: {
    ...mapMutations([mTypes.forgetModal]),
    tabToggle (tabName) {
      this.tab.activeName = tabName
      this.styles.pic2 = ['pic2', tabName].join(' ')
    },
    toMsgShow(item){
      console.log('click msg:',item)
      if(item.type===2){
        this.$router.push({
          path: '/msg',
          query: {
            id:item.id,
          }
        })
      }
      if(item.type===3){
        this.openwindow(item.url,'',700,650);
      }
    },
    toggle_cihuiliangceping(){
      this.cihuiliangceping_close=false;
      this.mingzhu_close=true;
      this.kebiao_close=true;
    },
    toggle_mingzhu(){

      this.mingzhu_close=false;
      this.cihuiliangceping_close=true;
      this.kebiao_close=true;

    },
    toggle_coursepage(){
      if(this.userInfo){
        if(this.userInfo.course_schedule){
          this.$router.replace('/new_index');
        }else{
          if(this.brand_info.org_id===0){
            this.$router.replace('/new_index');
          }else{
            this.$router.replace('/mycourse');
          }
        }
      }
    },
    toggle_kebiao(){

      this.kebiao_close=false;
      this.mingzhu_close=true;
      this.cihuiliangceping_close=true;

    },
    async sendPhoneValidateCode () {
      if (this.sendPhoneValidateCodeDisabled) {
        console.log('click sendPhoneValidateCode repeat....')
        return false
      } else {
        if (!this.mobile) {
          this.$message.error('手机号不能为空')
          return false
        }
        const loadingHide = this.$message.loading('发送中...', 0)
        let res = await sendSms({
          username: this.mobile,
          type: 5
        })
        setTimeout(loadingHide)
        if (res.status === 'success') {
          this.$message.success('手机验证码已发送')
          let time = 60
          this.sendPhoneValidateCodeDisabled = true
          let timer = setInterval(() => {
            if (time === 0) {
              clearInterval(timer)
              this.sendPhoneValidateCodeDisabled = false
              this.sendPhoneValidateCodeText = '获取验证码'
            } else {
              this.sendPhoneValidateCodeDisabled = true
              this.sendPhoneValidateCodeText = time + '秒后可重新发送'
              time--
            }
          }, 1000)
        }
      }
    },
    async submitForm () {
      if (this.submitButtonStatus === 'loading') {
        console.log('login loading....')
        return false
      }

      if (this.tab.activeName === 'normalLogin') {
        if (!this.mobile) {
          this.$message.error('手机号不能为空')
          return false
        }
        if (!this.password) {
          this.$message.error('密码不能为空')
          return false
        }

        this.submitButtonStatus = 'loading'
        const loadingHide = this.$message.loading('登录中...', 0)

        let res = await userLogin({
          username: this.mobile,
          password: this.password
        })
        if(res && res.data && res.data.set_brand_info){
          store.commit(mTypes.brand_info, res.data.set_brand_info)
          window.localStorage.setItem('mfy_brand_config',JSON.stringify(res.data.set_brand_info))
        }
        setTimeout(loadingHide)
        this.submitButtonStatus = ''

        if (res.code === 1) {
          this.$message.success('登录成功')
          if (res.data.status === 4) {
            this.$router.push({
              path: '/register',
              query: { step: '2' }
            })
          } else {

            this.toggle_coursepage();

          }
        }
      } else {

        if (!this.mobile) {
          this.$message.error('手机号不能为空')
          return false
        }
        if (!this.phoneValidateCode) {
          this.$message.error('手机验证码不能为空')
          return false
        }

        this.submitButtonStatus = 'loading'
        const loadingHide = this.$message.loading('登录中...', 0)

        let res = await fastLogin({
          mobile: this.mobile,
          code: this.phoneValidateCode,
        })

        this.submitButtonStatus = ''
        setTimeout(loadingHide)

        if (res.code === 1) {
          this.$message.success('登录成功')
          if (res.data.status === 4) {
            this.$router.push({
              path: '/register',
              query: { step: '2' }
            })
          } else {
            this.toggle_coursepage();
          }
        }
      }
    },
    resetPwd () {
      this[mTypes.forgetModal]({ visible: true })
    },
  },
  created () {
    this.logoImageUrl = store.state.brand_info.site_admin_layout_logo_url||'';
  },
  mounted () {
    this.toggle_kebiao();
    this.toggle_coursepage();
  },
}
</script>